/* Guide Finder directory — list + interactive map, client-side filtering & sync.
   Reads window.GF_PARTNERS (built by scripts/build-feed.mjs). Spec §5.2–5.3. */
(function () {
  'use strict';
  var root = document.getElementById('gf-dir');
  if (!root || !window.GF_PARTNERS) return;
  var DATA = window.GF_PARTNERS;
  var BASE = window.GF_PROFILE_BASE || '/pages/guide-finder';
  var REDUCE = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var isMobile = function () { return window.matchMedia('(max-width: 700px)').matches; };
  var el = function (id) { return document.getElementById(id); };

  var listEl = el('gf-list'), countEl = el('gf-count'), emptyEl = el('gf-empty'),
      stateSel = el('gf-state'), waterSel = el('gf-water'), speciesWrap = el('gf-species'),
      qInput = el('gf-q'), typeSeg = el('gf-type'), clearBtn = el('gf-clear'),
      listPane = el('gf-listpane'), sheetPill = el('gf-sheet-pill'), mapEl = el('gf-map');

  var SPECIES = ['Trout', 'Bass', 'Walleye', 'Saltwater', 'Salmon', 'Panfish', 'Musky/Pike', 'Catfish'];
  var WATER = ['Fly', 'Freshwater', 'Saltwater', 'Ice'];
  var STATE_FULL = { AL:'Alabama',AK:'Alaska',AZ:'Arizona',AR:'Arkansas',CA:'California',CO:'Colorado',CT:'Connecticut',DE:'Delaware',FL:'Florida',GA:'Georgia',HI:'Hawaii',ID:'Idaho',IL:'Illinois',IN:'Indiana',IA:'Iowa',KS:'Kansas',KY:'Kentucky',LA:'Louisiana',ME:'Maine',MD:'Maryland',MA:'Massachusetts',MI:'Michigan',MN:'Minnesota',MS:'Mississippi',MO:'Missouri',MT:'Montana',NE:'Nebraska',NV:'Nevada',NH:'New Hampshire',NJ:'New Jersey',NM:'New Mexico',NY:'New York',NC:'North Carolina',ND:'North Dakota',OH:'Ohio',OK:'Oklahoma',OR:'Oregon',PA:'Pennsylvania',RI:'Rhode Island',SC:'South Carolina',SD:'South Dakota',TN:'Tennessee',TX:'Texas',UT:'Utah',VT:'Vermont',VA:'Virginia',WA:'Washington',WV:'West Virginia',WI:'Wisconsin',WY:'Wyoming' };
  var BADGE = { listed: 'Listed', verified: 'Verified', dealer: 'Dealer', ambassador: 'Ambassador' };

  var F = { type: '', state: '', species: [], water: '', q: '', selected: '' };
  var map = null, mapReady = false, cardByHandle = {};

  /* ---------- URL state ---------- */
  function hydrate() {
    var p = new URLSearchParams(location.search);
    F.type = p.get('type') || '';
    F.state = (p.get('state') || '').toUpperCase();
    F.water = p.get('water') || '';
    F.species = (p.get('species') || '').split(',').filter(Boolean);
    F.q = p.get('q') || '';
    F.selected = p.get('p') || '';
  }
  function syncURL() {
    var p = new URLSearchParams();
    if (F.type) p.set('type', F.type);
    if (F.state) p.set('state', F.state);
    if (F.species.length) p.set('species', F.species.join(','));
    if (F.water) p.set('water', F.water);
    if (F.q) p.set('q', F.q);
    if (F.selected) p.set('p', F.selected);
    var qs = p.toString();
    history.replaceState(null, '', qs ? location.pathname + '?' + qs : location.pathname);
  }

  /* ---------- filtering ---------- */
  function matches(pt) {
    if (F.type && pt.type !== F.type) return false;
    if (F.state && pt.state !== F.state) return false;
    if (F.water && (pt.water || []).indexOf(F.water) < 0) return false;
    if (F.species.length) {
      var ok = false;
      for (var i = 0; i < F.species.length; i++) { if ((pt.species || []).indexOf(F.species[i]) >= 0) { ok = true; break; } }
      if (!ok) return false;
    }
    if (F.q) { var q = F.q.toLowerCase(); if ((pt.name + ' ' + pt.city).toLowerCase().indexOf(q) < 0) return false; }
    return true;
  }
  function anyFilter() { return !!(F.type || F.state || F.species.length || F.water || F.q); }

  /* ---------- build filter UI ---------- */
  function buildControls() {
    var states = {};
    DATA.forEach(function (p) { if (p.state) states[p.state] = true; });
    Object.keys(states).sort().forEach(function (s) {
      var o = document.createElement('option'); o.value = s; o.textContent = STATE_FULL[s] || s; stateSel.appendChild(o);
    });
    WATER.forEach(function (w) { var o = document.createElement('option'); o.value = w; o.textContent = w; waterSel.appendChild(o); });
    SPECIES.forEach(function (s) {
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'gf-chip'; b.textContent = s; b.setAttribute('aria-pressed', 'false'); b.dataset.species = s;
      b.addEventListener('click', function () {
        var i = F.species.indexOf(s);
        if (i >= 0) F.species.splice(i, 1); else F.species.push(s);
        b.setAttribute('aria-pressed', i >= 0 ? 'false' : 'true');
        apply();
      });
      speciesWrap.appendChild(b);
    });
  }
  function reflectControls() {
    Array.prototype.forEach.call(typeSeg.querySelectorAll('button'), function (b) {
      var on = b.dataset.type === F.type; b.classList.toggle('is-active', on); b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    stateSel.value = F.state; waterSel.value = F.water; qInput.value = F.q;
    Array.prototype.forEach.call(speciesWrap.children, function (b) {
      b.setAttribute('aria-pressed', F.species.indexOf(b.dataset.species) >= 0 ? 'true' : 'false');
    });
    clearBtn.hidden = !anyFilter();
  }

  /* ---------- list ---------- */
  function badgeHtml(tier) {
    var cls = tier === 'ambassador' ? 'ambassador' : (tier === 'verified' || tier === 'dealer') ? 'verified' : 'listed';
    return '<span class="gf-card-badge gf-card-badge--' + cls + '">' + (BADGE[tier] || 'Listed') + '</span>';
  }
  function esc(s) { return (s || '').replace(/[&<>"]/g, function (c) { return { '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;' }[c]; }); }

  function renderList(list) {
    listEl.innerHTML = '';
    cardByHandle = {};
    var frag = document.createDocumentFragment();
    list.forEach(function (p) {
      var tags = [('<span class="gf-card-tag gf-card-tag--type">' + (p.type === 'shop' ? 'Shop' : 'Guide') + '</span>')]
        .concat((p.species || []).map(function (s) { return '<span class="gf-card-tag">' + esc(s) + '</span>'; })).join('');
      var card = document.createElement('button');
      card.type = 'button'; card.className = 'gf-card'; card.dataset.handle = p.handle;
      card.innerHTML =
        '<div class="gf-card-name">' + esc(p.name) + badgeHtml(p.tier) + '</div>' +
        '<div class="gf-card-sub">' + (p.person ? esc(p.person) + ' — ' : '') + esc(p.city) + ', ' + esc(p.state) + '</div>' +
        '<div class="gf-card-tags">' + tags + '</div>';
      card.addEventListener('click', function () { select(p.handle, { fly: true }); });
      frag.appendChild(card);
      cardByHandle[p.handle] = card;
    });
    listEl.appendChild(frag);
    emptyEl.hidden = list.length > 0;
    countEl.textContent = list.length + (list.length === 1 ? ' partner' : ' partners');
  }

  /* ---------- map ---------- */
  function featureCollection() {
    return {
      type: 'FeatureCollection',
      features: DATA.map(function (p) {
        return {
          type: 'Feature',
          id: p.handle,
          geometry: { type: 'Point', coordinates: [p.lon, p.lat] },
          properties: { handle: p.handle, type: p.type, m: matches(p) ? 1 : 0 }
        };
      })
    };
  }
  function loadMapLibre(cb) {
    if (window.maplibregl) return cb();
    var css = document.createElement('link');
    css.rel = 'stylesheet'; css.href = 'https://cdn.jsdelivr.net/npm/maplibre-gl@4.7.1/dist/maplibre-gl.css';
    document.head.appendChild(css);
    var s = document.createElement('script');
    s.src = 'https://cdn.jsdelivr.net/npm/maplibre-gl@4.7.1/dist/maplibre-gl.js';
    s.onload = cb; s.onerror = function () { mapEl.innerHTML = '<div style="padding:24px;color:#6F6B5E">Map unavailable — use the list.</div>'; };
    document.head.appendChild(s);
  }
  function brandStyle() {
    // Recolor the OpenFreeMap Positron base to brand tokens; declutter POI symbols.
    var layers = map.getStyle().layers || [];
    layers.forEach(function (ly) {
      try {
        var id = ly.id.toLowerCase();
        if (ly.type === 'background') map.setPaintProperty(ly.id, 'background-color', '#EDE7D6');
        else if (id.indexOf('water') >= 0 && ly.type === 'fill') map.setPaintProperty(ly.id, 'fill-color', '#DFEAE2');
        else if ((id.indexOf('park') >= 0 || id.indexOf('wood') >= 0 || id.indexOf('landcover') >= 0 || id.indexOf('landuse') >= 0) && ly.type === 'fill') map.setPaintProperty(ly.id, 'fill-color', '#E4DDC8');
        else if (id.indexOf('poi') >= 0 || (ly.type === 'symbol' && id.indexOf('place') < 0 && id.indexOf('state') < 0 && id.indexOf('country') < 0 && id.indexOf('city') < 0 && id.indexOf('town') < 0)) map.setLayoutProperty(ly.id, 'visibility', 'none');
      } catch (e) {}
    });
  }
  function addPins() {
    map.addSource('partners', { type: 'geojson', data: featureCollection(), promoteId: 'handle' });
    var opacity = ['case', ['==', ['get', 'm'], 1], 1, 0.22];
    var radius = ['case', ['boolean', ['feature-state', 'selected'], false], 13, 6.5];
    var stroke = ['case', ['boolean', ['feature-state', 'selected'], false], 3.5, 2.2];
    map.addLayer({ id: 'p-shop', type: 'circle', source: 'partners', filter: ['==', ['get', 'type'], 'shop'],
      paint: { 'circle-radius': radius, 'circle-color': '#211F1C', 'circle-stroke-color': '#F4EFE4', 'circle-stroke-width': stroke, 'circle-opacity': opacity, 'circle-stroke-opacity': opacity } });
    map.addLayer({ id: 'p-guide', type: 'circle', source: 'partners', filter: ['==', ['get', 'type'], 'guide'],
      paint: { 'circle-radius': radius, 'circle-color': '#3EDE8C', 'circle-stroke-color': '#211F1C', 'circle-stroke-width': stroke, 'circle-opacity': opacity, 'circle-stroke-opacity': opacity } });
    ['p-guide', 'p-shop'].forEach(function (layer) {
      map.on('click', layer, function (e) { select(e.features[0].properties.handle, { fromMap: true }); });
      map.on('mouseenter', layer, function () { map.getCanvas().style.cursor = 'pointer'; });
      map.on('mouseleave', layer, function () { map.getCanvas().style.cursor = ''; });
    });
  }
  function fitTo(list) {
    var pts = (list && list.length ? list : DATA);
    if (!pts.length) return;
    var b = new maplibregl.LngLatBounds();
    pts.forEach(function (p) { b.extend([p.lon, p.lat]); });
    map.fitBounds(b, { padding: 60, maxZoom: 9, animate: !REDUCE });
  }
  function refreshMap(list) {
    if (!mapReady) return;
    map.getSource('partners').setData(featureCollection());
  }
  function initMap() {
    loadMapLibre(function () {
      map = new maplibregl.Map({
        container: mapEl,
        style: 'https://tiles.openfreemap.org/styles/positron',
        center: [-98, 39.5], zoom: 3.2,
        cooperativeGestures: isMobile(),
        attributionControl: true
      });
      map.addControl(new maplibregl.NavigationControl({ showCompass: false }), 'top-right');
      map.on('load', function () {
        mapReady = true;
        try { brandStyle(); } catch (e) {}
        addPins();
        setTimeout(function () { try { map.resize(); } catch (e) {} fitTo(currentList()); }, 60);
        if (F.selected) select(F.selected, { fly: true, silent: true });
      });
      // MapLibre must be told to resize if its container gets its size after init.
      if (window.ResizeObserver) new ResizeObserver(function () { try { map.resize(); } catch (e) {} }).observe(mapEl.parentElement);
    });
  }

  /* ---------- selection / sync ---------- */
  var popup = null;
  function partner(h) { for (var i = 0; i < DATA.length; i++) if (DATA[i].handle === h) return DATA[i]; return null; }
  function clearSelectedState(h) { if (mapReady && h) try { map.setFeatureState({ source: 'partners', id: h }, { selected: false }); } catch (e) {} }

  function select(handle, opts) {
    opts = opts || {};
    var p = partner(handle); if (!p) return;
    var prev = F.selected;
    if (prev && prev !== handle) { clearSelectedState(prev); if (cardByHandle[prev]) cardByHandle[prev].classList.remove('is-selected'); }
    F.selected = handle;
    if (cardByHandle[handle]) {
      cardByHandle[handle].classList.add('is-selected');
      if (opts.fromMap) cardByHandle[handle].scrollIntoView({ block: 'nearest', behavior: REDUCE ? 'auto' : 'smooth' });
    }
    if (mapReady) {
      try { map.setFeatureState({ source: 'partners', id: handle }, { selected: true }); } catch (e) {}
      if (!opts.fromMap) {
        var mv = { center: [p.lon, p.lat], zoom: Math.max(map.getZoom(), 6) };
        REDUCE ? map.jumpTo(mv) : map.flyTo(mv);
      }
      openPopup(p);
    }
    if (opts.fromMap && isMobile()) openSheet(true);
    if (!opts.silent) syncURL();
  }
  function openPopup(p) {
    if (popup) popup.remove();
    var tags = [(p.type === 'shop' ? 'Shop' : 'Guide')].concat(p.species || []).slice(0, 4)
      .map(function (t) { return '<span class="gf-pop-tag">' + esc(t) + '</span>'; }).join('');
    var html = '<div class="gf-pop"><div class="gf-pop-name">' + esc(p.name) + badgeHtml(p.tier) + '</div>' +
      '<div class="gf-pop-sub">' + (p.person ? esc(p.person) + ' · ' : '') + esc(p.city) + ', ' + esc(p.state) + '</div>' +
      '<div class="gf-pop-tags">' + tags + '</div>' +
      '<a class="gf-pop-btn" href="' + BASE + '/' + p.handle + '">View profile →</a></div>';
    popup = new maplibregl.Popup({ offset: 14, closeButton: true, maxWidth: '260px' })
      .setLngLat([p.lon, p.lat]).setHTML(html).addTo(map);
    popup.on('close', function () {
      if (F.selected) { clearSelectedState(F.selected); if (cardByHandle[F.selected]) cardByHandle[F.selected].classList.remove('is-selected'); F.selected = ''; syncURL(); }
    });
  }

  /* ---------- mobile sheet ---------- */
  function openSheet(open) { listPane.classList.toggle('is-open', open); sheetPill.hidden = open; }

  /* ---------- apply ---------- */
  function currentList() { return DATA.filter(matches); }
  function apply() {
    var list = currentList();
    renderList(list);
    reflectControls();
    refreshMap(list);
    syncURL();
    if (F.selected && cardByHandle[F.selected]) cardByHandle[F.selected].classList.add('is-selected');
  }

  /* ---------- events ---------- */
  typeSeg.addEventListener('click', function (e) {
    var b = e.target.closest('button'); if (!b) return; F.type = b.dataset.type; apply();
  });
  stateSel.addEventListener('change', function () { F.state = stateSel.value; apply(); });
  waterSel.addEventListener('change', function () { F.water = waterSel.value; apply(); });
  var qt;
  qInput.addEventListener('input', function () { clearTimeout(qt); qt = setTimeout(function () { F.q = qInput.value.trim(); apply(); }, 150); });
  function clearAll() { F = { type: '', state: '', species: [], water: '', q: '', selected: F.selected }; apply(); }
  clearBtn.addEventListener('click', clearAll);
  Array.prototype.forEach.call(document.querySelectorAll('[data-gf-clear]'), function (b) { b.addEventListener('click', clearAll); });
  sheetPill.addEventListener('click', function () { openSheet(true); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && popup) popup.remove(); });

  /* ---------- init ---------- */
  hydrate();
  buildControls();
  apply();
  // Lazy-load the map when its container nears the viewport; always fall back on load.
  var mapStarted = false;
  function startMap() { if (mapStarted) return; mapStarted = true; initMap(); }
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (ents) {
      if (ents.some(function (e) { return e.isIntersecting; })) { io.disconnect(); startMap(); }
    }, { rootMargin: '300px' });
    io.observe(document.querySelector('.gf-mapwrap'));
  }
  window.addEventListener('load', function () { setTimeout(startMap, 500); });
  if (document.readyState === 'complete') setTimeout(startMap, 500);
})();
